<template>
  <section class="section container pt-0">
    <projects-datatable :module_settings="module_settings" />
  </section>
</template>

<script>
import { get_configuration } from "@/utils";
import ProjectsDatatable from "./projects_datatable/Index.vue";

export default {
  name: "AirProjectIndex",
  components: { ProjectsDatatable },
  data() {
    return {
      is_loading: false,
      module_settings: {},
    };
  },
  methods: {
    retrieve_settings() {
      let v = this;
      get_configuration(this)
        .then((conf) => {
          v.module_settings = conf;
        })
        .catch((error) => {
          console.error(error);
        });
    },
    create() {},
    refresh() {
      console.log("refresh orders");
    },
  },
  mounted() {
    this.retrieve_settings();
  },
  created() {},
};
</script>

<style scoped></style>
